<mat-checkbox [value]="value" (change)="handleCheck($event)">
  Tick this box to receive emails with the latest updates, exclusive offers, and
  valuable content.
</mat-checkbox>
